import script from "./AuthComponent.vue?vue&type=script&lang=js"
export * from "./AuthComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__